import { useEffect, useState } from 'react';

type Theme = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'uppdragsradar:theme';

/**
 * Tre lägen: uttryckligt ljust, uttryckligt mörkt, eller systemets val. Bara de
 * uttryckliga stämplar data-theme på roten – "system" lämnar den tom så att
 * prefers-color-scheme får styra.
 */
export function useTheme(): [Theme, (theme: Theme) => void] {
  const [theme, setTheme] = useState<Theme>(() => {
    try {
      return (localStorage.getItem(STORAGE_KEY) as Theme) ?? 'system';
    } catch {
      return 'system';
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'system') root.removeAttribute('data-theme');
    else root.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // Privat läge eller blockerade cookies – temat gäller ändå denna session.
    }
  }, [theme]);

  return [theme, setTheme];
}
